import { render, staticRenderFns } from "./UserCommentAdd.vue?vue&type=template&id=7f91c9c3&scoped=true&"
import script from "./UserCommentAdd.vue?vue&type=script&lang=js&"
export * from "./UserCommentAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserCommentAdd.vue?vue&type=style&index=0&id=7f91c9c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f91c9c3",
  null
  
)

export default component.exports